import type {PropsWithChildren} from 'react';
import {type ComponentProps, type FC} from 'react';

import {cn} from '@/modules/foundation/shared/tailwind';

type RadioTileFrameProps = Omit<ComponentProps<'input'>, 'type'> & {
	labelProps?: ComponentProps<'label'>;
};

export const RadioTileFrame: FC<PropsWithChildren<RadioTileFrameProps>> = ({
	className: inputClassName,
	labelProps: {className: labelClassName, ...restLabelProps} = {},
	children,
	...restInputProps
}) => {
	return (
		<label
			className={cn([
				'relative inline-flex items-center gap-2 overflow-hidden rounded-sm border-2 border-neutral-600 bg-neutral-800/50 leading-0 font-semibold select-none',
				'has-checked:border-primary has-checked:outline-2 has-checked:-outline-offset-4 has-checked:outline-neutral-800',
				'has-focus:ring-primary has-focus:ring-2 has-focus:ring-offset-2 has-focus:ring-offset-neutral-800 has-focus-visible:ring-yellow-400',
				labelClassName,
			])}
			{...restLabelProps}
		>
			<input type="radio" className={cn(['sr-only', inputClassName])} {...restInputProps} />
			{children}
		</label>
	);
};
